import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface IncomingCallState {
  open: boolean;
}

const initialState: IncomingCallState = {
  open: false,
};

export const incomingSlice = createSlice({
  name: "incomingCall",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});

export const { setOpen } = incomingSlice.actions;

export default incomingSlice.reducer;
